import React from "react";
import { DialogContent } from "@mui/material";
import type { DialogContentProps } from "@mui/material/DialogContent";
import { mergeSeeditDialogSx, seeditDialogContentSx } from "./dialog-layout.styles";

export const SeeditDialogContent: React.FC<DialogContentProps> = ({ sx, ...props }) => (
  <DialogContent sx={mergeSeeditDialogSx(seeditDialogContentSx, sx)} {...props} />
);
